import Modal from 'components/player/shared/modal/component';
import React from 'react';
import PropTypes from 'prop-types';
TemplateEntityEditingModal.propTypes = {
    id: PropTypes.string,
    stageEditModalOpen: PropTypes.bool,
    stages: PropTypes.array,
    onModalClose: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired
};
export default function TemplateEntityEditingModal(_a) {
    var _b = _a.stageEditModalOpen, stageEditModalOpen = _b === void 0 ? false : _b, onModalClose = _a.onModalClose, children = _a.children;
    return (React.createElement(Modal, { expanded: stageEditModalOpen, modalInnerClasses: 'modal__inner--lg text-align-center', onClose: function () { return onModalClose(); }, lightboxUnclosable: true, lightboxClasses: 'lightbox--closed-top' }, stageEditModalOpen && children));
}
